import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

const Dynamic = () =>
{
	const {id} = useParams();
	const current_user = useSelector((state) => state.current_user);
	let file = false;
	try
	{
		file = require('../cust/'+current_user.utype+'/pages/'+id+'.jsx');
	}
	catch(ex){ console.log('The dynamic page does not exists.'); }
	if(file)
	{
		const Component = file.default;
		return <div className="wrapper flex flex-wrap flex-col">
			<Component />
		</div>
	}
	return null;
}

export default Dynamic;